import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex xs:flex-col border-t border-b border-t-white border-b-white" }
const _hoisted_2 = { class: "p-3 w-full text-center flex flex-col items-center border-r-yellow-400" }
const _hoisted_3 = { class: "border border-white rounded-full w-10 h-10 flex mb-2 icon-color justify-center items-center" }
const _hoisted_4 = { class: "p-3 w-full text-center flex flex-col items-center" }
const _hoisted_5 = { class: "border border-white rounded-full w-10 h-10 flex mb-2 icon-color justify-center items-center" }
const _hoisted_6 = { class: "flex icon-text" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { class: "flex icon-text" }
const _hoisted_9 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Icon, {
          id: "pencil",
          source: "images/papsi_phone.svg",
          width: 24
        })
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-xl font-bold mb-1" }, "Customer Support", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", null, " Smart: 0998-588-1969 ", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", null, " Globe: 0915-096-6361 ", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", null, " customer@pafcpic365.com ", -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Icon, {
          id: "pencil",
          source: "images/papsi_social_media.svg",
          width: 24
        })
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-full mb-1" }, [
        _createElementVNode("span", { class: "text-xl font-bold" }, "Social Media")
      ], -1)),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Icon, {
            source: "images/Facebook_f_logo.png",
            class: "pr-1",
            width: 20
          }),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              href: "https://www.facebook.com/pafcpic",
              target: "_blank",
              rel: "noreferrer",
              textContent: _toDisplayString(_ctx.lang('facebook.text'))
            }, null, 8, _hoisted_7)
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Icon, {
            source: "images/Instagram_logo.png",
            class: "pr-1",
            width: 20
          }),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              href: "https://www.instagram.com/pafcpicofficial/ ",
              target: "_blank",
              rel: "noreferrer",
              textContent: _toDisplayString(_ctx.lang('instagram.text'))
            }, null, 8, _hoisted_9)
          ])
        ])
      ])
    ])
  ]))
}